"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueAutoCheckInDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
/**
 * A weekly auto check-in at a venue: on every one of `weekdays`, during `timeSlot`, the user is
 * treated as planning to be there. Backed by ordinary visit plans (generated inside the usual
 * booking window, see VenueVisitPlanDto.autoCheckInPublicId), plus an on-device geofence that
 * checks the user in when they arrive and a reminder push if they haven't by the slot's reminder
 * time.
 */
class VenueAutoCheckInDto {}
exports.VenueAutoCheckInDto = VenueAutoCheckInDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueAutoCheckInDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueAutoCheckInDto.prototype, "venuePublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueAutoCheckInDto.prototype, "venueName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], VenueAutoCheckInDto.prototype, "venueLogoUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueAutoCheckInDto.prototype, "venueLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueAutoCheckInDto.prototype, "venueLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [Number],
  example: [1, 3]
}), __metadata("design:type", Array)], VenueAutoCheckInDto.prototype, "weekdays", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueVisitPlanTimeSlot
}), __metadata("design:type", String)], VenueAutoCheckInDto.prototype, "timeSlot", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueAutoCheckInDto.prototype, "createdAt", void 0);
//# sourceMappingURL=VenueAutoCheckIn.dto.js.map